import { CSSProperties, FunctionComponent, useContext } from 'react'
import * as Constants from './services/Constants'
import ElectronIPC from './services/ElectronIPC'
import { AppContext, AppContextType } from './AppContext'

export const WindowTitleBarBase: FunctionComponent<{ windowName: string; children?: React.ReactNode }> = (props) => {
    // Note on -webkit-app-region: We used to use this to simulate the title bar
    // on Windows, but this was somehow blocking the mouse events of the screen
    // control libraries when the title bar was clicked; the screen control library's
    // mouse control events would get stuck until the "real mouse" emits a click and
    // unlocks it. This happened with both robotjs and enigo, suggesting some fundamental
    // limitation. We went around this by using this method of implementing the title bar
    // instead: see <https://github.com/electron/electron/issues/1354#issuecomment-1335826144>.
    // Related variables:
    //   - isTitleBarDragEnabled
    //   - _isTitleBarDragEnabled
    //   - registerWindowDragger

    const { state: appState } = useContext(AppContext) as AppContextType

    const win32NativeDragEnabled = appState.appState.remoteDesktopBeingControlledStatus

    const titlebarStyles: CSSProperties = {
        // @ts-ignore
        ...(win32NativeDragEnabled ? {} : { WebkitAppRegion: 'drag' }),
        height: Constants.title_bar_height,
        minHeight: Constants.title_bar_height,
        backgroundColor: 'rgba(255,255,255,0.03)',
        padding: 0,
        margin: 0,
    }

    const titleStyles: CSSProperties = {
        position: 'fixed',
        top: 0,
        left: 0,
    }

    const titlebarButtonsContainer: CSSProperties = {
        // @ts-ignore
        WebkitAppRegion: 'no-drag',
        position: 'fixed',
        height: Constants.title_bar_height,
        top: 0,
        right: 0,
        display: 'flex',
    }

    // NOTE: is not invoked when `WebkitAppRegion: 'drag'` is set.
    const onMouseDown = () => {
        // enable drag
        ElectronIPC.setWindowOptions({ windowName: props.windowName, isTitleBarDragEnabled: true })
    }

    // NOTE: is not invoked when `WebkitAppRegion: 'drag'` is set.
    const onMouseUp = () => {
        // disable drag
        ElectronIPC.setWindowOptions({ windowName: props.windowName, isTitleBarDragEnabled: false })
    }

    return (
        <div
            key={`div-win32NativeDragEnabled=${win32NativeDragEnabled}`}
            style={titlebarStyles}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
        >
            <div style={titleStyles}></div>
            <div style={titlebarButtonsContainer}>{props.children}</div>
        </div>
    )
}
